import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Linkedin, Shield, Heart, Star, Users } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { usePageMeta } from '../hooks/usePageMeta';

const teamMembers = [
  {
    name: 'Krishna Panikar',
    role: 'Founder / CEO',
    image: 'https://customer-assets.emergentagent.com/job_be30ae40-a6df-4d93-b7c3-0e8881463244/artifacts/yori4z6g_Krishna%20Panikar.jpg',
    linkedin: 'https://www.linkedin.com/in/krishnapanikar/',
    imagePosition: 'center top',
  },
  {
    name: 'Shawn Casey',
    role: 'Delivery Head',
    image: 'https://customer-assets.emergentagent.com/job_be30ae40-a6df-4d93-b7c3-0e8881463244/artifacts/iqdihqmm_Shawn%20Pic.png',
    linkedin: 'https://www.linkedin.com/in/shawn-casey-9861b21/',
    imagePosition: 'center top',
  },
  {
    name: 'Gaurav Sharma',
    role: 'Vice President - Recruitment',
    image: 'https://customer-assets.emergentagent.com/job_be30ae40-a6df-4d93-b7c3-0e8881463244/artifacts/zpte0acr_Gaurav.jpg',
    linkedin: 'https://www.linkedin.com/in/gaursharma/',
    imagePosition: 'center top',
  },
  {
    name: 'Prateek Modi',
    role: 'Director HealthCare',
    image: 'https://customer-assets.emergentagent.com/job_be30ae40-a6df-4d93-b7c3-0e8881463244/artifacts/wc0ivhzr_Prateek%20Modi.png',
    linkedin: 'https://www.linkedin.com/in/pratikmodi07/',
    imagePosition: 'center 20%',
  },
  {
    name: 'Aayushi Singh',
    role: 'Asst. Manager - HR, Accounting and US Payroll',
    image: 'https://customer-assets.emergentagent.com/job_digitive-rebuild-1/artifacts/d4m4x29c_Aayushi01.jpg',
    linkedin: 'https://www.linkedin.com/in/aayushi-singh-b256b5233/',
    imagePosition: 'center top',
  },
  {
    name: 'Gulshan Chauhan',
    role: 'Account Manager',
    image: 'https://customer-assets.emergentagent.com/job_be30ae40-a6df-4d93-b7c3-0e8881463244/artifacts/xv3qxdpo_Gulshan%20Singh%20Chauhan%20.png',
    linkedin: 'https://www.linkedin.com/in/gulshan-singh-chauhan-b99505125/',
    imagePosition: 'center top',
  },
  {
    name: 'Amit Ratnani',
    role: 'Recruitment Manager',
    image: 'https://customer-assets.emergentagent.com/job_f0c940e7-3e12-43aa-bd22-2bc177215e38/artifacts/z9ghjdnv_AmitR.png',
    linkedin: 'https://www.linkedin.com/in/amit-ratnani-9b089794/',
    imagePosition: 'center top',
  },
  {
    name: 'Simona Gupta',
    role: 'Recruitment Manager',
    image: 'https://customer-assets.emergentagent.com/job_f0c940e7-3e12-43aa-bd22-2bc177215e38/artifacts/pjgsaq71_Screenshot%202026-04-09%20at%204.09.35%E2%80%AFPM.png',
    linkedin: 'https://www.linkedin.com/in/simona-gupta-759bb3190/',
    imagePosition: 'center top',
  },
  {
    name: 'Rosey Borah',
    role: 'Sr. Healthcare Recruiter',
    image: 'https://customer-assets.emergentagent.com/job_be30ae40-a6df-4d93-b7c3-0e8881463244/artifacts/y61b9rm8_Roslyn%20Borah.jpg',
    linkedin: 'https://www.linkedin.com/in/rossyborah/',
    imagePosition: 'center top',
  },
  {
    name: 'Babar Khan',
    role: 'Sr. Healthcare Recruiter',
    image: 'https://customer-assets.emergentagent.com/job_be30ae40-a6df-4d93-b7c3-0e8881463244/artifacts/xd397jxd_Babar.jpg',
    linkedin: 'https://www.linkedin.com/in/babar-khan-110865113/',
    imagePosition: 'center 10%',
  },
  {
    name: 'Riya Pundir',
    role: 'Sr. Healthcare Recruiter',
    image: 'https://customer-assets.emergentagent.com/job_digitive-rebuild-1/artifacts/yhf86hmg_Riya%20%28Sr.%20Healthcare%20Recruiter%29.png',
    linkedin: '',
    imagePosition: 'center top',
  },
  {
    name: 'Aarti Jangra',
    role: 'Healthcare Recruiter',
    image: 'https://customer-assets.emergentagent.com/job_be30ae40-a6df-4d93-b7c3-0e8881463244/artifacts/3zuk31c8_AArti.jpg',
    linkedin: 'https://www.linkedin.com/in/aarti-jangra-77a61a216/',
    imagePosition: 'center top',
  },
  {
    name: 'Harshita Kulkarni',
    role: 'Healthcare Recruiter',
    image: 'https://customer-assets.emergentagent.com/job_be30ae40-a6df-4d93-b7c3-0e8881463244/artifacts/mficna8e_Harshita%20Kulkarni.png',
    linkedin: 'https://www.linkedin.com/in/kulkarni-harshita/',
    imagePosition: 'center top',
  },
  {
    name: 'Anshita Paliwal',
    role: 'Healthcare Recruiter',
    image: 'https://customer-assets.emergentagent.com/job_be30ae40-a6df-4d93-b7c3-0e8881463244/artifacts/yvapbxly_Anshita%20Paliwal.jpg',
    linkedin: 'https://www.linkedin.com/in/anshita-paliwal-32274322b/',
    imagePosition: 'center top',
  },
  {
    name: 'Kushagri Singh',
    role: 'Senior Compliance Associate',
    image: 'https://customer-assets.emergentagent.com/job_f0c940e7-3e12-43aa-bd22-2bc177215e38/artifacts/0ogn7hg5_Image20260520135110.png',
    linkedin: 'https://www.linkedin.com/in/kushagri-singh-b4900b20b/',
    imagePosition: 'center top',
  },
  {
    name: 'Ashima Panikar',
    role: 'Healthcare Staffing Associate',
    image: 'https://customer-assets.emergentagent.com/job_f0c940e7-3e12-43aa-bd22-2bc177215e38/artifacts/qvl3ogqo_Screenshot%202026-05-20%20at%2011.23.59%E2%80%AFAM.png',
    linkedin: 'https://www.linkedin.com/in/ashima-panikar-943a921b5/',
    imagePosition: 'center top',
  },
  {
    name: 'Simran Joshi',
    role: 'Healthcare Staffing Associate',
    image: 'https://customer-assets.emergentagent.com/job_be30ae40-a6df-4d93-b7c3-0e8881463244/artifacts/qhjncn75_SimranJoshi.png',
    linkedin: 'https://www.linkedin.com/in/simran-joshi-1b271828a/',
    imagePosition: 'center 15%',
  },
  {
    name: 'Ruhi Khaparde',
    role: 'Onboarding Specialist',
    image: 'https://customer-assets.emergentagent.com/job_digitive-rebuild-1/artifacts/oucw3yd0_Ruhi01.jpg',
    linkedin: 'https://www.linkedin.com/in/ruhi-khaparde-589698221/',
    imagePosition: 'center top',
  },
];

const coreValues = [
  {
    icon: Shield,
    title: 'Integrity',
    description: 'We uphold honesty and transparency in every decision and action.',
  },
  {
    icon: Heart,
    title: 'Compassion',
    description: 'We approach every interaction with empathy, kindness, and respect.',
  },
  {
    icon: Star,
    title: 'Excellence',
    description: 'We are committed to the highest standards in service and performance.',
  },
  {
    icon: Users,
    title: 'Collaboration',
    description: 'We believe in the power of teamwork to achieve shared success.',
  },
];

export const AboutPage = () => {
  usePageMeta({
    title: 'About Us - Our Team & Mission',
    description: 'Meet the Digitive Health leadership team. Learn about our mission to deliver quality, compassion, and reliability in healthcare staffing nationwide.',
    path: '/about',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="about-page">
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <section className="pt-28 pb-16 bg-secondary relative overflow-hidden">
        <div className="container-width">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="text-left">
              <span className="inline-block text-sm font-medium tracking-widest uppercase text-primary/60 mb-4">
                About Us
              </span>
              <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-foreground mb-6">
                Your Trusted Healthcare Staffing Partner
              </h1>
              <p className="text-lg text-muted-foreground">
                Founded in 2019, our organization was built on a clear and powerful mission: to enhance healthcare delivery by connecting passionate professionals with purpose-driven facilities.
              </p>
            </div>
            
            {/* Right Image */}
            <div className="relative hidden lg:block">
              <div className="rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=600&h=400&fit=crop"
                  alt="Healthcare professionals in meeting"
                  className="w-full h-[350px] object-cover"
                  loading="lazy"
                  data-testid="about-hero-image"
                />
              </div>
              {/* Decorative elements */}
              <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-primary/20 rounded-full blur-xl" />
              <div className="absolute -top-4 -right-4 w-32 h-32 bg-primary/10 rounded-full blur-2xl" />
            </div>
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="section-padding">
        <div className="container-width">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-foreground mb-6">Our Story</h2>
              <div className="space-y-4 text-muted-foreground">
                <p className="text-lg leading-relaxed">
                  We believe that exceptional patient care starts with the right people in the right places—individuals who are not only skilled, but also deeply committed to making a difference.
                </p>
                <p className="text-lg leading-relaxed">
                  Over the years, we have partnered with hundreds of healthcare facilities across the United States, helping them maintain high standards of care by providing access to compassionate, qualified staff.
                </p>
                <p className="text-lg leading-relaxed">
                  Our story is one of dedication, growth, and a steadfast commitment to bridging the gap between healthcare talent and the communities that need them most.
                </p>
              </div>
            </div>
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://static.prod-images.emergentagent.com/jobs/3c79fc15-7acb-4945-a01c-dd7a9cf21362/images/7b9b9644b5aa1c0e235ef912b882a536031545058eb27f39d01bbc106ef897a5.png"
                  alt="Healthcare staffing team partnership and collaboration"
                  className="w-full h-[400px] object-cover"
                  data-testid="about-story-image"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-primary/10 rounded-full blur-2xl -z-10" />
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="section-padding bg-secondary">
        <div className="container-width">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-foreground">Our Core Values</h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {coreValues.map((value, index) => (
              <Card
                key={index}
                className="p-6 text-center card-hover border-border/50"
                data-testid={`value-card-${index}`}
              >
                <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center text-primary mx-auto mb-4">
                  <value.icon className="h-7 w-7" />
                </div>
                <h4 className="text-xl font-semibold text-foreground mb-2">
                  {value.title}
                </h4>
                <p className="text-muted-foreground text-sm">{value.description}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="section-padding" data-testid="team-section">
        <div className="container-width">
          <div className="text-center mb-12">
            <span className="inline-block text-sm font-medium tracking-widest uppercase text-primary/60 mb-4">
              Our Team
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground">
              Meet the People Behind Our Success
            </h2>
            <p className="text-muted-foreground mt-4 max-w-2xl mx-auto">
              Our dedicated team of professionals brings decades of combined experience in healthcare staffing.
            </p>
          </div>

          {/* Team Grid - Collage Style */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
            {teamMembers.map((member, index) => (
              <Card
                key={index}
                className="group overflow-hidden border-border/50 card-hover"
                data-testid={`team-member-${index}`}
              >
                <div className="relative">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full aspect-square object-cover"
                    loading="lazy"
                    style={{ objectPosition: member.imagePosition || 'center center' }}
                  />
                  {/* Overlay on hover */}
                  <div className="absolute inset-0 bg-primary/80 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-12 h-12 rounded-full bg-white flex items-center justify-center text-primary hover:scale-110 transition-transform"
                      data-testid={`linkedin-${index}`}
                    >
                      <Linkedin className="h-6 w-6" />
                    </a>
                  </div>
                </div>
                <div className="p-4 text-center">
                  <h4 className="font-semibold text-foreground text-sm">{member.name}</h4>
                  <p className="text-xs text-muted-foreground leading-tight mt-1">{member.role}</p>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-primary text-white">
        <div className="container-width text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Work With Us?</h2>
          <p className="text-white/80 mb-8 max-w-xl mx-auto">
            Whether you're looking for healthcare talent or seeking your next career opportunity, we're here to help.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/#contact">
              <Button 
                className="bg-white text-primary hover:bg-white/90 rounded-full px-8 py-6 text-base"
                data-testid="contact-btn"
              >
                Contact Us
              </Button>
            </Link>
            <Link to="/careers">
              <Button 
                variant="outline"
                className="border-white text-white hover:bg-white hover:text-primary rounded-full px-8 py-6 text-base"
                data-testid="view-jobs-btn"
              >
                View Open Positions
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default AboutPage;
